import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import parameters from "../utils/parameters";
import { useTranslation } from "react-i18next";

import ShowQuestion from "../submodule/src/App";

import { getRetrieval } from "../submodule/src/api/RetrievalsApi";
import {
  addQuestion,
  getChats,
  addFeedback,
  addFeedback2,
  matrixMode,
} from "../submodule/src/api/QuestionsApi";

import { addMessage } from "../submodule/src/api/MessagesApi";
import logo from "../assets/cs-logo.png";

const QuestionWithRetrieval = ({ defaultRetrievalId }) => {
  const { idRetrieval: paramRetrievalId, id } = useParams();
  const retrievalId = paramRetrievalId || defaultRetrievalId || null;
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);
  const otherReferences = false;

  useEffect(() => {
    const handleLanguageChange = () => {
      setCurrentLanguage(i18n.language);
    };

    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, [i18n]);

  return (
    <>
      <div className="w-11/12 mx-auto container">
        <ShowQuestion
          getRetrieval={getRetrieval}
          retrievalId={retrievalId}
          addQuestionRetData={id ? getChats : addQuestion}
          addMessage={addMessage}
          logo={logo}
          otherRefs={otherReferences}
          addFeedback={addFeedback}
          addFeedback2={addFeedback2}
          newApi={true}
          matrix_mode={true}
          addMatrixMode={matrixMode}
          colors={parameters.componentColors}
          allow_files={true}
          language={currentLanguage}
        />
      </div>
    </>
  );
};

export default QuestionWithRetrieval;
